package com.ustadmobile.redux

import redux.RAction

data class ReduxToolbarState(var title: String? = null): RAction
